module.exports = __webpack_public_path__ + "img/boutsex-logo-lg.c3c43618.svg";